import React, { useState } from 'react';
import { Box, Typography, Tabs, Tab, useTheme } from '@mui/material';
import { Icon } from '@iconify/react';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import CheckerAmendmentTable from '../components/CheckerAmendmentTable';
import CheckerCancellationTable from '../components/CheckerCancellationTable';
import CheckerLimitDeactivationTable from '../components/CheckerLimitDeactivationTable';
import CheckerPartnerPermissionTable from '../components/CheckerPartnerPermissionTable';
import CheckerBusinessKeywordTable from '../components/CheckerBusinessKeywordTable';
import CheckerHolidayCalendarTable from '../components/CheckerHolidayCalendarTable';
import CheckerCocCancellationTable from '../components/CheckerCocCancellationTable';
interface Props {
  onLogout: () => void;
}
interface TabPanelProps {
  index: number;
  value: number;
  children: React.ReactNode;
}
const TabPanel: React.FC<TabPanelProps> = ({
  index,
  value,
  children
}) => <div hidden={value !== index} data-id="element-3325" data-mp="3o7sbxno46t7k">{value === index && <Box sx={{
    pt: 2.5
  }} data-id="element-3326" data-mp="3o6zfbfivdk35">{children}</Box>}</div>;
const TAB_DEFS = [{
  label: 'Amendments',
  icon: 'lucide:clipboard-edit'
}, {
  label: 'Cancellations',
  icon: 'lucide:clipboard-check'
}, {
  label: 'Limit Changes',
  icon: 'lucide:shield-off'
}, {
  label: 'Partner Permissions',
  icon: 'lucide:sliders-horizontal'
}, {
  label: 'Business Keywords',
  icon: 'lucide:list-filter'
}, {
  label: 'Holiday Calendar',
  icon: 'lucide:calendar-days'
}, {
  label: 'COC Cancellations',
  icon: 'lucide:landmark'
}];
const CheckerInboxHub: React.FC<Props> = ({
  onLogout
}) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [tab, setTab] = useState(0);
  const theme = useTheme();
  return <Box sx={{
    display: 'flex',
    width: '100%',
    minHeight: '100vh',
    backgroundColor: 'background.default',
    overflow: 'hidden'
  }} data-id="element-3327" data-mp="3j9qx5exq1g1w">
      <TopBar onMenuClick={() => setMobileOpen(!mobileOpen)} onLogout={onLogout} title="Checker Inbox" data-id="element-3328" data-mp="2qrvarj7mcevb" />
      <Sidebar open={mobileOpen} onClose={() => setMobileOpen(false)} activePage="checker-approvals" data-id="element-3329" data-mp="3u2smfjhcgirl" />
      <Box component="main" sx={{
      flexGrow: 1,
      py: 2,
      px: {
        xs: 2,
        sm: 3,
        md: 5
      },
      width: {
        xs: '100%',
        sm: 'calc(100% - 240px)'
      },
      maxWidth: '100%',
      ml: 0,
      mt: 8,
      overflow: 'hidden'
    }} data-id="element-3330" data-mp="3p3xu9qxhlhut">
        <Box sx={{
        maxWidth: '100%'
      }} data-id="element-3331" data-mp="6rjb2xelz7d3">
          <Box sx={{
          display: 'flex',
          alignItems: 'center',
          mb: 2
        }} data-id="element-3332" data-mp="2p6302ce2xd5">
            <Icon icon="lucide:check-square" width={28} height={28} color="#0EA5E9" data-id="element-3333" data-mp="3b3n1ujgj3v7j" />
            <Typography variant="h5" component="h1" sx={{
            ml: 1.5,
            fontWeight: 600
          }} data-id="element-3334" data-mp="364tn6npi9y5s">Checker Inbox</Typography>
          </Box>

          <Tabs value={tab} onChange={(_, v) => setTab(v)} variant="scrollable" scrollButtons="auto" sx={{
          mb: 1,
          borderBottom: `1px solid ${theme.palette.divider}`
        }} data-id="element-3335" data-mp="3k54hy1txrww8">
            {TAB_DEFS.map(t => <Tab key={t.label} label={<Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }} data-id="element-3337" data-mp="ug2eayiswtyb"><Icon icon={t.icon} width={16} height={16} data-id="element-3338" data-mp="uhn98p912ewp" /><Typography variant="body2" fontWeight={700} data-id="element-3339" data-mp="12w1nrq0d74zm">{t.label}</Typography></Box>} data-id="element-3336" data-mp="ufasgff0aal8" />)}
          </Tabs>

          <TabPanel value={tab} index={0} data-id="element-3340" data-mp="16zg8uv35ubjx"><CheckerAmendmentTable data-id="element-3341" data-mp="16vk0vzly2brw" /></TabPanel>
          <TabPanel value={tab} index={1} data-id="element-3342" data-mp="sz5gfnm7cown"><CheckerCancellationTable data-id="element-3343" data-mp="szyem073i636" /></TabPanel>
          <TabPanel value={tab} index={2} data-id="element-3344" data-mp="xworyfrimnkw"><CheckerLimitDeactivationTable data-id="element-3345" data-mp="xxzygncci9fp" /></TabPanel>
          <TabPanel value={tab} index={3} data-id="element-3346" data-mp="1ln1a0jgh60p7"><CheckerPartnerPermissionTable data-id="element-3347" data-mp="1lnu7ettjnduo" /></TabPanel>
          <TabPanel value={tab} index={4} data-id="element-3348" data-mp="1lp5dj0agoxoy"><CheckerBusinessKeywordTable data-id="element-3349" data-mp="1qmdyf8mzvftw" /></TabPanel>
          <TabPanel value={tab} index={5} data-id="element-3350" data-mp="1qnypupe0iinj"><CheckerHolidayCalendarTable data-id="element-3351" data-mp="1bx9b5d1celex" /></TabPanel>
          <TabPanel value={tab} index={6} data-id="element-3352" data-mp="1bwgckzcjf27v"><CheckerCocCancellationTable data-id="element-3353" data-mp="1bv57mw7cvof6" /></TabPanel>
        </Box>
      </Box>
    </Box>;
};
export default CheckerInboxHub;